export {AnchorSimilarHotels} from './AnchorSimilarHotels'
